import { Model } from '@vuex-orm/core'

export default class StudentTeam extends Model {
    
    static entity = 'student_team'
  
    static primaryKey = ['student_id', 'team_id']
  
    static fields () {
        return {
            student_id: this.attr(null),
            team_id: this.attr(null),
            deleted_at: this.attr(null)
        }
    }
}